import React, { useEffect, useState } from "react";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import AdminDashboard from "./AdminDashboard";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function AdminPage() {
    const location = useLocation();
    const navigate = useNavigate();
    const [user, setUser] = useState(location.state?.user || null);
    const [status, setStatus] = useState(location.state?.user ? "ok" : "checking");

    useEffect(() => {
        if (location.state?.user) return;
        const check = async () => {
            // CRITICAL: skip /me if returning from OAuth callback (handled by AuthCallback)
            if (window.location.hash?.includes("session_id=")) {
                return;
            }
            try {
                const res = await axios.get(`${API}/auth/me`, {
                    withCredentials: true,
                });
                setUser(res.data);
                setStatus("ok");
            } catch (err) {
                setStatus("unauthorized");
                navigate("/login", { replace: true });
            }
        };
        check();
    }, [location.state, navigate]);

    if (status === "checking" || !user) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <div className="text-center">
                    <Loader2 className="h-7 w-7 animate-spin mx-auto text-primary mb-3" />
                    <p className="text-muted-foreground text-sm">Verificando sesión...</p>
                </div>
            </div>
        );
    }

    return <AdminDashboard user={user} onLogout={() => setUser(null)} />;
}
